import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { Sending } from './Sending';

export const Message = types.compose(
  BaseEntity,
  types.model('Message', {
    messageId: types.identifierNumber,
    title: types.string,
    body: types.string,
    type: types.maybe(types.string),
    sendings: types.optional(types.array(Sending), []),
    isSender: types.maybe(types.boolean),
    isBeneficiary: types.maybe(types.boolean),
    statusCode: types.maybe(types.string),
    statusName: types.maybe(types.string),
    senderName: types.maybe(types.string),
    recipientName: types.maybe(types.string),
    eventType: types.maybe(types.string),
    recipientMailAddress: types.maybe(types.string),
    sender: types.maybe(types.string),
    sendingId: types.maybe(types.integer),
    timestamp: types.maybe(types.Date),
    MessageType: types.maybe(types.string),
  }),
);

export enum MessageSelectionMode {
  Affiliates1 = 'affiliates-1',
  Affiliates3 = 'affiliates-3',
  AffiliatesAll = 'affiliates',
  AffiliatesGroupOne = 'affiliates-group-one',
  AffiliatesGroupSeveral = 'affiliates-group-several',
  One = 'one',
  Several = 'several',
  OnDuty = 'onDuty',
  Neighbors = 'neighbors',
  FromTableResult = 'from-table-result',
  Test = 'test',
}

export type MessageToSend = {
  messageId: number;
  body: string;
  htmlContent: string;
  title: string | null;
  recipientId: number | undefined;
  recipientIds: number[];
  selectionMode: MessageSelectionMode;
  dutyType: string;
  dutyDate: Date | null;
  dayOnly: boolean;
  nightOnly: boolean;
  dayNight: boolean;
  radius: number;
  secretariatId?: number;
  groupId?: number;
  groupIds?: number[];
  fileList: File[];
  fileData: number[][];
  fileNames: string[];
  fileTypes: string[];
  testEmailAddress: string | null;
};
